module.exports = __webpack_public_path__ + "img/199.6832faa5.jpg";